document.addEventListener('DOMContentLoaded', () => {
	tabsLogos();
});

const tabsLogos = () => {
	const sections = document.querySelectorAll('.js-tabs-logos');

	sections.forEach(section => {
		const navItems = section.querySelectorAll('.js-nav-item');
		const tabs = section.querySelectorAll('.js-tab');
		const triggers = section.querySelectorAll('.js-tab-trigger');

		const deactivateAllTabs = () => {
			navItems.forEach(item => item.classList.remove('active'));
			tabs.forEach(tab => tab.classList.remove('active'));
		};

		const setActiveTab = (index) => {
			deactivateAllTabs();
			if (navItems[index]) navItems[index].classList.add('active');
			if (tabs[index]) tabs[index].classList.add('active');
		};

		navItems.forEach((nav, index) => {
			nav.addEventListener('click', () => setActiveTab(index));
		});

		triggers.forEach(trigger => {
			trigger.addEventListener('click', () => {
				const tabEl = trigger.closest('.js-tab');
				const tabIndex = Array.from(tabs).indexOf(tabEl);

				if (tabIndex === -1) return;

				const isActive = tabEl.classList.contains('active');

				if (isActive) {
					tabEl.classList.remove('active');
				} else {
					deactivateAllTabs();
					tabEl.classList.add('active');
				}
			});
		});
	});
};
